import type { ReactNode } from 'react';
import { translateKey } from '../../../../../translate';
import { InlineElement } from '../../../../elements/common';
import { FormRow } from '../../../../elements/forms/FormRow';
import { StackedFormGroup } from '../../../../elements/forms/StackedFormGroup';

export function DatePeriodSelection(props: {
    endDate: ReactNode;
    infixLabel?: string;
    label?: string;
    startDate: ReactNode;
}) {
    return (
        <FormRow>
            {props.label && (
                <StackedFormGroup colSizeAuto>
                    <InlineElement className="inline-label">{`${props.label} ${translateKey(
                        'common.from'
                    )}`}</InlineElement>
                </StackedFormGroup>
            )}
            <StackedFormGroup>{props.startDate}</StackedFormGroup>
            <StackedFormGroup colSizeAuto>
                <InlineElement className="inline-label">{props.infixLabel ?? translateKey('common.to')}</InlineElement>
            </StackedFormGroup>
            <StackedFormGroup>{props.endDate}</StackedFormGroup>
        </FormRow>
    );
}
